/* Saturday Skin Amazon CTA tracking v2.0.0. Rollback: remove the named Liquid block. */
(function () {
  'use strict';
  var pages = {'canada-meta-yuzu-vitamin-c-sleep-mask-amazon': ['B08VVRG88M', 'Yuzu Vitamin C Sleep Mask', 'meta', 'www.amazon.ca'],
    'amazon-yuzu-vitamin-c-sleep-mask': ['B08VVRG88M', 'Yuzu Vitamin C Sleep Mask', 'tiktok'],
    'amazon-rub-a-dub-refining-peel-gel': ['B07CYYSNVV', 'Rub-A-Dub Refining Peel Gel', 'tiktok'],
    'tt-perilla-pore-serum-amazon': ['B0H2ZX111Y', 'Perilla Pore Serum', 'tiktok'],
    'meta-yuzu-vitamin-c-sleep-mask-amazon': ['B08VVRG88M', 'Yuzu Vitamin C Sleep Mask', 'meta'],
    'meta-rub-a-dub-refining-peel-gel-amazon': ['B07CYYSNVV', 'Rub-A-Dub Refining Peel Gel', 'meta'],
    'meta-perilla-pore-serum-amazon': ['B0H2ZX111Y', 'Perilla Pore Serum', 'meta']
  };
  var match = location.pathname.match(/\/pages\/([^/]+)\/?$/);
  var handle = match && match[1];
  var product = pages[handle];
  if (!product || window.__ssAmazonCTA_v1 || (window.Shopify && window.Shopify.designMode)) return;
  window.__ssAmazonCTA_v1 = true;
  // Consent is fresh on each landing-page visit; no URL flag grants permission.
  var pageConsent = false;
  var choiceEpoch = 0;
  var pendingChoice = false;
  var panel = document.createElement('aside');
  panel.id = 'ss-amazon-privacy';
  panel.setAttribute('aria-label', 'Advertising preferences');
  panel.style.cssText = 'box-sizing:border-box;position:fixed;right:16px;bottom:16px;z-index:2147482990;width:min(390px,calc(100vw - 32px));padding:20px;background:#fff8f7;color:#262626;border:1px solid #e5cdcc;border-radius:12px;font:14px/1.5 Arial,sans-serif;box-shadow:0 4px 24px #0002';
  var details = document.createElement('div');
  var heading = document.createElement('strong'); heading.textContent = 'Advertising preferences'; heading.style.fontSize='17px';
  var description = document.createElement('p');
  description.textContent = 'Allow website analytics and advertising cookies, including sharing your Amazon button clicks with Meta and TikTok to measure and improve our ads? You can decline and still shop. Click sharing lasts for this page visit; change your choice here anytime.';
  description.style.cssText='margin:10px 0';
  var policy = document.createElement('a'); policy.href='/pages/privacy-policy'; policy.textContent='Privacy policy'; policy.style.cssText='color:inherit;text-decoration:underline';
  var actions = document.createElement('div'); actions.style.cssText='display:flex;gap:10px;margin-top:14px';
  var approve = document.createElement('button'); approve.type='button'; approve.textContent='Allow';
  var decline = document.createElement('button'); decline.type='button'; decline.textContent='Decline';
  [approve,decline].forEach(function(button){button.style.cssText='flex:1;min-height:44px;border:1px solid #262626;border-radius:5px;padding:9px 16px;background:#fff;color:#262626;font:inherit;cursor:pointer';});
  var manage = document.createElement('button'); manage.type='button'; manage.textContent='Advertising preferences'; manage.style.cssText='min-height:44px;border:0;background:none;color:#262626;font:14px Arial,sans-serif;text-decoration:underline;cursor:pointer';manage.hidden=true;
  var status = document.createElement('p');status.setAttribute('role','status');status.style.cssText='font-size:12px;margin:10px 0 0';status.hidden=true;
  [heading,description,policy,actions].forEach(function(node){details.appendChild(node);});
  actions.appendChild(decline);actions.appendChild(approve);
  [details,manage,status].forEach(function(node){panel.appendChild(node);});
  document.body.appendChild(panel);
  function showDetails(show) {
    details.hidden=!show;manage.hidden=show;
    panel.style.padding=show?'20px':'2px 10px';
    panel.style.width=show?'min(390px,calc(100vw - 32px))':'auto';
  }
  manage.addEventListener('click',function(){showDetails(true);decline.focus();});
  function notice(message){status.textContent=message;status.hidden=!message;}
  function publishChoice(granted) {
    var analytics=window.Shopify && window.Shopify.analytics;
    if (!analytics || typeof analytics.publish!=='function') return Promise.reject(new Error('Publisher unavailable'));
    try {return Promise.resolve(analytics.publish('ss_amazon_consent',{granted:granted,version:'2.0.0'}));}
    catch(error){return Promise.reject(error);}
  }
  function revokeLocal(message){
    choiceEpoch++;pendingChoice=false;pageConsent=false;approve.disabled=false;
    publishChoice(false).catch(function(){});
    notice(message || 'Amazon click sharing is off.');showDetails(false);
  }
  function privacyAPI(callback) {
    var shopify=window.Shopify;
    if(shopify && shopify.customerPrivacy){callback(null,shopify.customerPrivacy);return;}
    if(!shopify || typeof shopify.loadFeatures!=='function'){callback(new Error('Consent unavailable'));return;}
    shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error){callback(error,shopify.customerPrivacy);});
  }
  // Serialize writes so an older Allow cannot finish after a newer Decline.
  var privacyWrites=[];
  var privacyWriting=false;
  function writePrivacyChoice(value,epoch,callback) {
    privacyWrites.push({value:value,epoch:epoch,callback:callback});
    drainPrivacyWrites();
  }
  function drainPrivacyWrites() {
    if(privacyWriting || !privacyWrites.length)return;
    privacyWriting=true;
    var request=privacyWrites.shift();
    var finished=false;
    function finish(error,p) {
      if(finished)return;
      finished=true;
      try {request.callback(error,p);}
      finally {privacyWriting=false;drainPrivacyWrites();}
    }
    privacyAPI(function(error,p){
      if(error || !p){finish(error || new Error('Consent unavailable'));return;}
      if(request.value.marketing && request.epoch!==choiceEpoch){finish(new Error('Choice superseded'));return;}
      try {
        p.setTrackingConsent(request.value,function(result){finish(result && result.error ? new Error('Consent not saved') : null,p);});
      } catch(error) {finish(error);}
    });
  }
  function declineChoice() {
    revokeLocal('Amazon click sharing is off.');
    writePrivacyChoice({analytics:false,marketing:false,sale_of_data:false},choiceEpoch,function(){});
  }
  decline.addEventListener('click',function(event){if(event.isTrusted)declineChoice();});
  approve.addEventListener('click',function(event){
    if(!event.isTrusted || pendingChoice)return;
    if(navigator.globalPrivacyControl===true){notice('Your browser privacy preference prevents advertising data sharing.');return;}
    var epoch=++choiceEpoch;pendingChoice=true;approve.disabled=true;notice('Saving your choice…');
    writePrivacyChoice({analytics:true,marketing:true,sale_of_data:true},epoch,function(error,p){
      if(epoch!==choiceEpoch)return;
      if(error || !p){pendingChoice=false;approve.disabled=false;notice('Your choice could not be saved. Click sharing remains off.');return;}
        pendingChoice=false;approve.disabled=false;
        pageConsent=true;
        if(!allowed()){pageConsent=false;notice('Your privacy settings prevent advertising data sharing.');return;}
        publishChoice(true).then(function(){
          if(epoch!==choiceEpoch)return;
          notice('Amazon click sharing is on. Choose Decline to withdraw.');showDetails(false);
        }).catch(function(){if(epoch===choiceEpoch){pageConsent=false;notice('Click sharing is unavailable. You can still shop.');}});
    });
  });
  // Immediate refusal and opening NextRoll preferences stop this page's new tracking.
  // Existing partners and banner configuration are not changed.
  document.addEventListener('click',function(event){
    var target=event.target instanceof Element && event.target.closest('#adroll_consent_reject,#adroll_consent_reject_all,#adroll_consent_persistent_icon_href,#adroll_consent_settings,.adroll_consent_banner_partners_link_class,#adroll_consent_allow_N');
    if(!event.isTrusted || !target)return;
    if(target.id==='adroll_consent_reject' || target.id==='adroll_consent_reject_all') {declineChoice();return;}
    if(pageConsent || pendingChoice)revokeLocal('Privacy choices changed. Amazon click sharing is off.');
  },true);
  document.addEventListener('visitorConsentCollected',function(){
    if(pageConsent && !allowed())revokeLocal('Your privacy settings turned Amazon click sharing off.');
  });
  // A resolved TCF refusal also stops sharing if NextRoll omits its DOM signal.
  // Late Allow/open notifications must not undo our newer explicit page choice.
  var tcfRegistered=false;
  var tcfPurposes={},tcfVendors={};
  // Copy resolved flags: CMP callbacks can reuse objects or omit an unchanged map.
  function recordTCFConsent(previous,current) {
    var withdrawn=false;
    Object.keys(current || {}).forEach(function(key){
      var value=current[key];
      if(typeof value!=='boolean')return;
      if(previous[key]===true && value===false)withdrawn=true;
      previous[key]=value;
    });
    return withdrawn;
  }
  function watchTCF(){
    if(tcfRegistered || typeof window.__tcfapi!=='function')return;
    tcfRegistered=true;
    window.__tcfapi('addEventListener',2,function(data,success){
      if(!success || !data || data.cmpStatus!=='loaded' || !data.tcString ||
          (data.eventStatus!=='tcloaded' && data.eventStatus!=='useractioncomplete'))return;
      var purposeWithdrawn=recordTCFConsent(tcfPurposes,data.purpose && data.purpose.consents);
      var vendorWithdrawn=recordTCFConsent(tcfVendors,data.vendor && data.vendor.consents);
      if(data.eventStatus==='useractioncomplete' && (pageConsent || pendingChoice) &&
          (data.purpose?.consents?.[1]===false || purposeWithdrawn || vendorWithdrawn)) {
        revokeLocal('Privacy choices changed. Amazon click sharing is off.');
      }
    });
  }
  watchTCF();
  var tcfAttempts=0;
  var tcfTimer=setInterval(function(){watchTCF();if(tcfRegistered || ++tcfAttempts>=120)clearInterval(tcfTimer);},500);

  var lastClicks = new WeakMap();
  var pendingNavigation = null;
  // Give the Shopify sandbox and provider queues a bounded opportunity to send
  // before an ordinary same-tab Amazon click unloads this page.
  function shouldDelayNavigation(event, anchor) {
    if (event.type !== 'click' || event.button !== 0 || !event.cancelable ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || anchor.hasAttribute('download')) return false;
    var base = document.querySelector('base[target]');
    var target = anchor.getAttribute('target') || (base && base.getAttribute('target')) || '';
    return !target || target.toLowerCase() === '_self';
  }
  function cancelNavigation() {
    if (!pendingNavigation) return;
    clearTimeout(pendingNavigation.timer);
    pendingNavigation = null;
  }
  function finishNavigation(navigation) {
    if (pendingNavigation !== navigation) return;
    cancelNavigation();
    location.assign(navigation.href);
  }
  function delayNavigation(event, anchor) {
    var navigation = {anchor: anchor, href: anchor.href};
    navigation.timer = setTimeout(function () { finishNavigation(navigation); }, 600);
    pendingNavigation = navigation;
    event.preventDefault();
    if (!event.defaultPrevented) cancelNavigation();
    return navigation;
  }
  function allowed() {
    var p = window.Shopify && window.Shopify.customerPrivacy;
    return !!(pageConsent && p && typeof p.analyticsProcessingAllowed === 'function' && p.analyticsProcessingAllowed() &&
      typeof p.marketingAllowed === 'function' && p.marketingAllowed() &&
      typeof p.saleOfDataAllowed === 'function' && p.saleOfDataAllowed());
  }
  function isAmazonCTA(anchor) {
    if (!anchor) return false;
    try {
      var url = new URL(anchor.href, location.href);
      return url.protocol === 'https:' && url.hostname === (product[3] || 'www.amazon.com') &&
        url.pathname.split('/dp/')[1]?.split('/')[0] === product[0];
    } catch (_) { return false; }
  }
  function onClick(event) {
    try {
      if (!event.isTrusted || event.defaultPrevented || (event.type === 'click' ? event.button !== 0 : event.button !== 1)) return;
      var target = event.target instanceof Element ? event.target : event.target && event.target.parentElement;
      var anchor = target && target.closest('a[href]');
      if (!anchor) return;
      var delay = shouldDelayNavigation(event, anchor);
      if (pendingNavigation && delay) {
        // A second click must not bypass or restart the first click's handoff.
        if (pendingNavigation.anchor === anchor && pendingNavigation.href === anchor.href) {
          event.preventDefault();
          return;
        }
        // A later ordinary link choice supersedes the pending destination.
        cancelNavigation();
      }
      if (!isAmazonCTA(anchor) || !allowed()) return;
      var analytics = window.Shopify && window.Shopify.analytics;
      if (!analytics || typeof analytics.publish !== 'function') return;
      var now = Date.now();
      if (now - (lastClicks.get(anchor) || 0) < 750) return;
      lastClicks.set(anchor, now);
      var links = Array.prototype.filter.call(document.querySelectorAll('a[href]'), isAmazonCTA);
      var result = analytics.publish('ss_amazon_cta_clicked', {
        version: '2.0.0', consent_version: '2026-09-14', landing_page: handle, campaign_source: product[2],
        amazon_asin: product[0], content_name: product[1],
        cta_position: 'cta_' + (links.indexOf(anchor) + 1),
        destination: 'amazon',
        click_id: window.crypto && typeof window.crypto.randomUUID === 'function' ? window.crypto.randomUUID() :
          'ss-' + now + '-' + Math.random().toString(36).slice(2)
      });
      var navigation = delay ? delayNavigation(event, anchor) : null;
      if (result && typeof result.catch === 'function') result.catch(function () {
        // Publishing failures must never strand someone on the landing page.
        if (navigation) finishNavigation(navigation);
      });
    } catch (_) { /* Tracking must never interfere with navigation. */ }
  }
  document.addEventListener('click', onClick, {passive: false});
  document.addEventListener('auxclick', onClick, {passive: true});
})();
